import cx from 'classnames';
import type { ChangeEvent, ReactNode, VoidFunctionComponent } from 'react';

import { icons } from '../Icon';
import Toggle from '../Toggle';
import TooltipIcon from '../TooltipIcon';
import type { TooltipPlacement } from '../Tooltip';

import css from './LabeledToggle.module.less';

type LabeledToggleProps = {
  label: ReactNode;
  id?: string;
  isChecked: boolean;
  isDisabled?: boolean;
  onChange: (isChecked: boolean, event: ChangeEvent<HTMLInputElement>) => void;
  testId?: string;
  tooltip?: string;
  tooltipPlacement?: TooltipPlacement;
  className?: string;
};

export const LabeledToggle: VoidFunctionComponent<LabeledToggleProps> = ({
  label,
  id,
  isChecked,
  isDisabled,
  onChange,
  testId,
  tooltip,
  tooltipPlacement,
  className,
}) => {
  const labelContent = tooltip ? (
    <span className={css.labelWithTooltip}>
      <span>{label}</span>
      <span className={css.tooltipIcon}>
        <TooltipIcon
          id={`tooltip-${id || ''}`}
          icon={icons.questionCircleO}
          tooltip={tooltip}
          placement={tooltipPlacement}
          testId={`tooltip-${id || ''}`}
        />
      </span>
    </span>
  ) : label;

  return (
    <label className={cx(css.labeledToggle, className)} htmlFor={id}>
      <Toggle
        id={id}
        checked={isChecked}
        onChange={onChange}
        isDisabled={isDisabled}
        data-testid={testId}
      />
      <span className={css.label}>{labelContent}</span>
    </label>
  );
};
